import { StatuteCodeEnum } from '../models';

export const BELGIUM_COUNTRY_CODE = 'BE';

export const WORKER_STUDENT_STATUTE_CODES: Array<Partial<StatuteCodeEnum>> = [
  StatuteCodeEnum.LABOUR_STUDENT_WORKER,
  StatuteCodeEnum.WHITE_COLLAR_STUDENT_WORKER,
];

export const WHITE_COLLAR_STATUTE_CODES: ReadonlySet<StatuteCodeEnum> = new Set([
  StatuteCodeEnum.WHITE_COLLAR_STUDENT_WORKER,
  StatuteCodeEnum.FLEX_WHITE_COLLAR,
  StatuteCodeEnum.WHITE_COLLAR,
  StatuteCodeEnum.WHITE_COLLAR_STUDENT,
]);

export const WHITE_COLLAR_FIRST_PC_CODES: ReadonlySet<string> = new Set(['300']);

export const BYTES_IN_KILOBYTE = 1000;
